import React from 'react'
import Image from 'next/image'
import { Search } from '../Search.js'

const Google = ({ kbLangKey, q, i18n, sectionKey }) => {
    return (
        <Search
            {...{ kbLangKey, q, i18n, sectionKey }}
            LogoArea={() => (
                <div style={{ margin: '16px' }}>
                    <Image
                        src={'/images/google_logo.png'}
                        border='0'
                        alt='Google'
                        width='276'
                        height='93'
                        align='center'
                        priority='true'
                    />
                </div>
            )}
        />
    )
}

export default Google
